import React from "react";

const CPTooltip = (params: any) => {
  const data = params.data;

  if (data?.role === "OP") {
    return (
      <div className="bg-gray-300 px-1 shadow-lg dark:bg-[#171717]">
        {data.executionRequestCounterParties?.map((cp: any, index: number) => (
          <div className="py-1" key={index}>
            <div>{cp.provider}</div>
            {cp.deskRestrictions && cp.deskRestrictions.length > 0 &&
              cp.deskRestrictions.map((desk: string, deskIndex: number) => (
                <div key={deskIndex}>- {desk}</div>
              ))
            }
          </div>
        ))}
      </div>
    );
  }

  // if (data?.role === "RP") {
  //   return (
  //     <div className="bg-gray-300 px-1 shadow-lg dark:bg-[#171717]">
  //       <div>{data.provider}</div>
  //     </div>
  //   );
  // }

  if (data?.deskRestrictions && data.deskRestrictions.length > 0) {
    return (
      <div className="bg-gray-300 px-1 shadow-lg dark:bg-[#171717]">
        <div>
          <div>{data.provider}</div>
          {data.deskRestrictions.map((desk: string, index: number) => (
            <div className="py-1" key={index}>
              - {desk}
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="bg-gray-300 px-1 shadow-lg dark:bg-[#171717]">
      <div>{data?.provider}</div>
    </div>
  );
};

export default CPTooltip;
